import React from "react";
import { Switch } from "../../../../components/ui/switch";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "../../../../contexts/I18nProvider";
import { selectAfricanOnly } from "../../../../redux/selectors/filterSelectors";
import { toggleAfricanOnly } from "../../../../redux/slices/filterSlice";
import { cn } from "../../../../lib/utils";

function AfricanOnlyInput({ variant = "card", className }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const africanOnly = useSelector(selectAfricanOnly);
  const isInline = variant === "inline";

  return (
    <div
      className={cn(
        "polyglot-african-only flex w-full items-center justify-between rounded-xl border border-input bg-white",
        isInline ? "px-3 py-2 gap-3" : "p-4",
        className
      )}
    >
      <div className={cn(isInline ? "text-sm font-medium" : "space-y-0.5")}>
        <label
          className={cn(
            "font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
            isInline ? "text-sm" : "text-base"
          )}
          htmlFor="african-only"
        >
          {t('polyglot.africanOnly')}
        </label>
        {!isInline && (
          <p
            id="african-only-description"
            className="text-sm font-normal text-muted-foreground"
          >
            {t('polyglot.africanOnlyDescription')}
          </p>
        )}
      </div>
      <Switch
        id="african-only"
        onCheckedChange={() => dispatch(toggleAfricanOnly())}
        checked={africanOnly}
      />
    </div>
  );
}

export default AfricanOnlyInput;
